import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
@Component({
  name: 'CmgMessageBar',
})
export default class CmgMessageBar extends Vue {

  get visible() {
    return this.$appStore.state.ui.messageBanner.visible;
  }

  get messageText() {
    return this.$appStore.state.ui.messageBanner.message;
  }

  get timeout() {
    return this.$appStore.state.ui.messageBanner.timeoutMs;
  }

  close(): void {
    this.$services.ui.setMessageBannerState({
      message: ``,
      visible: false
    });
  }
 
  @Watch('visible', { immediate: true, deep: true })
  onVisibleChanged(visible: boolean) {
    if (visible) {
      setTimeout(() => {
        this.close();
      }, this.timeout);
    }
  }
}
